/**
 * i18n de Costos y stock (v3): un archivo por área para que cada pantalla escriba en el suyo
 * sin pisarse con las demás. Acá se mergean en un solo módulo { es, en, pt }, que
 * translations.js suma al resto y parity.test.js controla como uno más.
 *
 * Prefijos (los controla costsV3.test.js):
 *   shell   → cs.shell.*                                   (navegación y común)
 *   platos  → cs.platos.*  cs.ajustes.*
 *   plato   → cs.plato.*
 *   insumos → cs.insumos.* cs.stock.*
 *   compra  → cs.compra.*  cs.contar.*  cs.perdida.*  cs.activar.*
 */
import shell from "./shell";
import platos from "./platos";
import plato from "./plato";
import insumos from "./insumos";
import compra from "./compra";

export const AREAS = { shell, platos, plato, insumos, compra };

const merge = (loc) => Object.assign({}, ...Object.values(AREAS).map((a) => a[loc] || {}));

const costsV3 = { es: merge("es"), en: merge("en"), pt: merge("pt") };

export default costsV3;
